import React from 'react';

import Modal from 'ub/components/modal';
import { Button } from 'comp/button';

import styles from './WarningModal.scss';
import icon from 'ub/icons/modal/warning.svg';

// Simple stateless modal with a warning icon.
export default function WarningModal({ children, onClose, title }) {
  return (
    <Modal
      closePortal={onClose}
      title={title}
      modalFooter={
        <Button type="action" size="small" closeModal>
          Got it!
        </Button>
      }
    >
      <div className={styles.wrapper}>
        <div
          className={styles.icon}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: icon }}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </Modal>
  );
}

WarningModal.propTypes = {
  onClose: React.PropTypes.func.isRequired,
  children: React.PropTypes.node.isRequired,
  title: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/WarningModal.jsx